import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-home-03',
  standalone: true,
  templateUrl: '../../assets/home-03.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamHome03Icon {}
